import { AxiosInstance } from 'axios';

/**
 * Asks the API to stop a scenario run it is carrying.
 *
 * Written by hand next to the generated client, like the other endpoints that arrived after it was last
 * regenerated. The API answers 202 as soon as the stop is asked for: the scenario that is going is skipped and the
 * configuration from before the run is restored first, and the run's own state says when it has ended.
 */
export const stopScenarioRun = async (
    axios: AxiosInstance,
    customer: string,
    environment: string,
    runId: string
): Promise<void> => {
    await axios.post(
        `/ScenarioRun/${encodeURIComponent(customer)}/${encodeURIComponent(
            environment
        )}/${encodeURIComponent(runId)}/stop`
    );
};
